export default __webpack_public_path__ + "static/media/ux.172478b6.svg";